import { inject, Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';

import { CartStoreRefiner } from '@common/refiners/cart.refiner';
import { OrderStoreSelector } from '@common/selectors/order.selector';

import {
  CartMerchantAmountBlockDataSource,
  CartMerchantAmountBlockViewModel,
} from './cart-merchant-amount-block-view-model';

@Injectable()
export class CartMerchantAmountBlockStoreDataSource implements CartMerchantAmountBlockDataSource {
  private readonly cartRefiner = inject(CartStoreRefiner);
  private readonly orderSelector = inject(OrderStoreSelector);

  readonly vm$: Observable<CartMerchantAmountBlockViewModel> = combineLatest({
    orderValidateData: this.orderSelector.selectValidation$,
    isOrderValidating: this.orderSelector.selectIsValidating$,
    cartHasProduct: this.cartRefiner.selectActiveCartProducts.pipe(
      map(products => !!products.length),
    ),
  }).pipe(
    map(({ orderValidateData, isOrderValidating, cartHasProduct }) => ({
      orderValidateData,
      isOrderValidating,
      cartHasProduct,
      orderHasProduct: !!orderValidateData?.products?.length,
    })),
  );
}
